import React, {useState} from 'react'
import {useLocation, useNavigate, useParams} from "react-router-dom";
import ProjectSummary from "./ProjectSummary";
import {Tabs} from "antd";
import PositionCostOverview from "./PositionCostOverview";
import Icon from '../../../components/Icon';
import BriefRoleTab from "./BriefRoleTab";
import BriefDetailsTab from "./BriefDetailsTab";
import ProjectFormProvider, {useProjectForm} from "../../../providers/ProjectFormProvider";
import {useProject} from "../../../providers/ClientProjectProvider";
import {useMount, useWindowSize} from "react-use";
import ProjectDeliverablesTable from "../../client-lead-tools/project-scope/ProjectDeliverablesTable";
import ReviewProjectScope from "./ReviewProjectScope";
import {useAuth} from "../../../providers/AuthProvider";
import PositionFormProvider from "../../../providers/PositionFormProvider";
import {ProjectPositionProvider} from "../../../providers/ProjectPositionProvider";


const Tab = {
    Details: 'details',
    Scope: 'scope',
    Roles: 'role-requirements',
    Cost: 'cost',
};
const ProjectPositionsCostOverview = props => {

    const {auth} = useAuth();
    const {project, isLoading, isProjectUpdating, formModel} = useProjectForm();

    const positions = project?.positions || []


    const [editingPosition, setEditingPosition] = useState(null);
    if (isLoading || !formModel || !project || !auth) return null;
    const canEditProjectAndPositions = auth?.canEditProjectAndPositions(project);

    const editDisabled = !canEditProjectAndPositions || project.is_on_hold || (project.hasRequestedSOW() && !auth.isClientConsultant());

    return (
        <div>
            {TB.map(positions, (position, index) => (
                <ProjectPositionProvider key={`ppr-${position.id}`} positionId={position.id}>
                    <PositionFormProvider positionId={position.id}>
                        <PositionCostOverview
                            hideOverrideTools={false}
                            canEdit={!editDisabled && (!editingPosition || editingPosition === position.id) && !position.hasBeenFilled()}
                            onEdit={(editing) => setEditingPosition(editing ? position.id : null)}
                            isEditing={editingPosition === position.id}
                            isDisabled={isProjectUpdating}/>
                    </PositionFormProvider>
                </ProjectPositionProvider>
            ))}
        </div>
    );
};

const BiddingBrief = (props) => {
    const {project, isLoading, isProjectUpdating} = useProject();
    const {width, height} = useWindowSize();
    const {section} = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    // const { auth } = useAuth();

    useMount(async () => {
        if (!project.isActive() && !project.canEditScope()) {
            await TB.sysAlert('team_shopping.project_summary_view_tab_visit_tip')
        }
    })

    const viewTab = (tab) => {
        if (section === tab) {
            return;
        }
        return navigate({
            ...location,
            pathname: './../' + tab
        }, {replace: true})
    }

    return (
        <div className="review-step-container">
            <div className="wizard-position-step wizard-review-step">
                <div className={
                    TB.mapClass({"project-review-step": true, "no-edit": props.isDisabled})}>

                    <div className="project-review-container pt-10 project-review-container-tabs flex-col">

                        <Tabs
                            defaultActiveKey="details"
                            tabPosition={width > 720 ? 'left' : 'top'}
                            onChange={console.log}
                            activeKey={section}
                            onTabClick={viewTab}
                            tabBarStyle={{marginRight: 20}}
                            items={[
                                {
                                    label: (
                                        <div className="flex justify-between items-center">
                                            <div className="flex items-center">
                                                <Icon name="file" className="mr-2"/>
                                                <span>Project Brief</span>
                                            </div>

                                            {/*<i className={`ml-4 fas fa-chevron-right ${section === Tab.Details ? 'visible' : 'invisible'}`}></i>*/}
                                        </div>
                                    ),
                                    key: Tab.Details,
                                    className: 'bg-white flex flex-col items-stretch px-0',
                                    children: (
                                        <div className={TB.mapClass("flex flex-col items-stretch", {
                                            "px-[24px] py-[32px]": section === Tab.Details
                                        })}>
                                            <div className="flex review-tabs bidding-brief-tabs">
                                                {section === Tab.Details && (
                                                    <div className="review-tab-section active-tab-section block">
                                                        {project && (
                                                            <ProjectFormProvider>
                                                                <BriefDetailsTab
                                                                    toggleDisabled={props.toggleDisabled}
                                                                    isDisabled={props.isDisabled}/>
                                                            </ProjectFormProvider>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ),
                                },
                                project.isService() ? {
                                    label: (
                                        <div className="flex justify-between items-center">
                                            <div className="flex items-center">
                                                <Icon name="user-check" className="mr-2"/>
                                                <span>Scope</span>
                                            </div>

                                            {/*<i className={`ml-4 fas fa-chevron-right ${section === Tab.Roles ? 'visible' : 'invisible'}`}></i>*/}
                                        </div>
                                    ),
                                    key: Tab.Scope,
                                    className: 'bg-white flex flex-col items-stretch px-0',
                                    children: (
                                        <div className={TB.mapClass("flex flex-col items-stretch", {
                                            "px-[24px] py-[32px]": section === Tab.Roles
                                        })}>
                                            <div className="flex review-tabs bidding-brief-tabs">
                                                {section === Tab.Scope && (
                                                    <div className="review-tab-section active-tab-section block">
                                                        {project && (
                                                            <ProjectFormProvider>
                                                                <div className="p-3">
                                                                    <ReviewProjectScope linkParams="?fromScope=1"/>
                                                                </div>
                                                            </ProjectFormProvider>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ),
                                } : {
                                    label: (
                                        <div className="flex justify-between items-center">
                                            <div className="flex items-center">
                                                <Icon name="user-check" className="mr-2"/>
                                                <span>Positions</span>
                                            </div>

                                            {/*<i className={`ml-4 fas fa-chevron-right ${section === Tab.Roles ? 'visible' : 'invisible'}`}></i>*/}
                                        </div>
                                    ),
                                    key: Tab.Roles,
                                    className: 'bg-white flex flex-col items-stretch px-0',
                                    children: (
                                        <div className={TB.mapClass("flex flex-col items-stretch", {
                                            "px-[24px] py-[32px]": section === Tab.Roles
                                        })}>
                                            <div className="flex review-tabs bidding-brief-tabs">
                                                {section === Tab.Roles && (
                                                    <div className="review-tab-section active-tab-section block">
                                                        {project && (
                                                            <ProjectFormProvider>
                                                                <BriefRoleTab onUpdateRole={async (callback) => {
                                                                    await props.toggleDisabled(true);
                                                                    let finish = await callback();
                                                                    await props.toggleDisabled(false);
                                                                    return finish;
                                                                }} isDisabled={props.isDisabled}/>
                                                            </ProjectFormProvider>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ),
                                },
                                {
                                    label: (
                                        <div className="flex justify-between items-center">
                                            <div className="flex items-center">
                                                <Icon name="dollar" className="mr-2"/>
                                                <span>Estimated Price</span>
                                            </div>

                                            {/*<i className={`ml-4 fas fa-chevron-right ${section === Tab.Cost ? 'visible' : 'invisible'}`}></i>*/}
                                        </div>
                                    ),
                                    key: Tab.Cost,
                                    className: 'bg-white flex flex-col items-stretch px-0',
                                    children: (
                                        <div className={TB.mapClass("flex flex-col items-stretch", {
                                            "px-[24px] py-[32px]": section === Tab.Cost
                                        })}>
                                            <div className="flex review-tabs bidding-brief-tabs">
                                                {section === Tab.Cost && (
                                                    project && (
                                                        <ProjectFormProvider>

                                                            <ProjectSummary biddingBrief/>

                                                            {project.isBYO() ? <ProjectPositionsCostOverview/> :
                                                                <ProjectDeliverablesTable/>}

                                                        </ProjectFormProvider>
                                                    )
                                                )}
                                            </div>
                                        </div>
                                    ),
                                },
                            ]}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default BiddingBrief;